exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.full-overlay[data-v-281f5c22]{\n\tposition: fixed;\n\tz-index: 100;\n\tleft: 0;\n\ttop: 0;\n\twidth: 100%;\n\theight: 100%;\n\tbackground: rgba(0,0,0,0.6);\n\n\tdisplay: flex;\n\tbox-orient: vertical;\n\tbox-pack: center;\n}\n", ""]);
